import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ChangeOrderStatusAPI } from '../redux/actions/User/Detail/ChangeOrderStatusAction';
import { useDispatch, useSelector } from 'react-redux';
import { changeOrderStatusStateReset } from '../redux/slices/User/Detail/ChangeOrderStatusSlice';
import Swal from 'sweetalert2';

const Success = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const orderId = searchParams.get('orderId');
    const redirectStatus = searchParams.get('redirect_status');
    const paymentIntent = searchParams.get('payment_intent');

    const { response: changeOrderStatusResponse } = useSelector((state) => state.changeOrderStatus);

    const handleSubmitComplete = async (orderId, status) => {
        try {
            const data = {
                orderId: orderId,
                status: status,
            };
            dispatch(ChangeOrderStatusAPI(data));
        } catch (error) {
            console.log('error in complete order request', error);
        }
    };


    // useEffect(() => {
    //     // Payment is done; clear flag so future payments can proceed
    //     localStorage.removeItem('paymentInProgress');

    //     // Optional: clear history so back button doesn’t show old form
    //     window.history.replaceState(null, '', window.location.href);
    // }, []);

    useEffect(() => {
        if (redirectStatus && paymentIntent && orderId) {

            localStorage.setItem(`payment_success_${orderId}`, 'true');
            handleSubmitComplete(orderId, 5);
        }
    }, [redirectStatus, paymentIntent, orderId]);

    useEffect(() => {
        if (changeOrderStatusResponse?.status === true) {
            dispatch(changeOrderStatusStateReset());

            // ✅ Show Swal modal instead of rendering JSX
            Swal.fire({
                icon: 'success',
                title: 'Payment Successful!',
                // text: 'You will be redirected to the order detail page shortly.',
                timer: 5000,
                showConfirmButton: false,
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                // didClose: () => {
                //     navigate(`/admin-dashboard/order-detail/supplier/${orderId}`, { replace: true });
                // },
            });

            navigate(`/admin-dashboard/order-management`, { state: { role: 'supplier' } });
        }
    }, [changeOrderStatusResponse]);

    return null; // ❌ No need to show <div>Success</div>
};

export default Success;
